import {
  SYNC_URL_COMPLETE,
  UPDATE_UI_PARAM,
  RESET_UI_PARAMS
} from '../constants';

// Payload structure: { queryString, lang, pathName, parameters }
export const syncUrlComplete = (payload) => ({
  type: SYNC_URL_COMPLETE,
  payload,
});

// Updates a specific key in the draft state (uiParams)
export const updateUiParam = (newData) => ({
  type: UPDATE_UI_PARAM,
  payload: newData,
});

// Discards changes in draft state
export const resetUiParams = () => ({
  type: RESET_UI_PARAMS,
});
